import { getColumnSolidBorderStyle } from '@bingads-webui-campaign-react/common-styles';

export const pageStyles = ({ palette = {} }) => ({
  title: {
    fontSize: '20px',
    fontFamily: 'Segoe UI',
    lineHeight: '28px',
    color: `${palette.neutralPrimary}`,
  },
  subtitlePrimary: {
    fontSize: '14px',
    fontFamily: 'Segoe UI',
    lineHeight: '20px',
    color: `${palette.neutralPrimary}`,
  },
  titleSecondary: {
    fontSize: '14px',
    fontFamily: 'Segoe UI',
    lineHeight: '20px',
    color: `${palette.neutralSecondary}`,
  },
  titleMargins: {
    margin: '16px auto 10px 32px',
  },
  sectionTitle: {
    fontSize: '18px',
    fontFamily: 'Segoe UI',
    lineHeight: '22px',
    color: `${palette.neutralPrimary}`,
    fontWeight: 'bold',
    marginTop: 8,
    marginBottom: 8,
  },
  sectionLabelContainer: {
    paddingTop: 8,
    paddingBottom: 8,
  },
  sectionLabel: {
    fontSize: '14px',
    fontFamily: 'Segoe UI',
    lineHeight: '20px',
    color: `${palette.neutralPrimary}`,
    fontWeight: 'bold',
    paddingRight: 8,
    display: 'inline',
  },
  gridCustomStyles: getColumnSolidBorderStyle(1, 2),
  gridWithNoSelectBox: getColumnSolidBorderStyle(),
});
